import { Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { BatchSummaryProps } from "./BatchSummaryProps";
import { batchSummaryStyles } from "./BatchSummaryStyles";

export default observer(function BatchSummary({ batchId, decision }: BatchSummaryProps) {
    const classes = batchSummaryStyles();
    const { thorEventViewStore } = useStore();
    const data = thorEventViewStore.eventSummary.batchSummaries
        .find((message) => message.batchId === batchId)!
        .message.split("\n");

    return (
        <div className={classes.container}>
            {data.map((message) => (
                <div key={message}>
                    <Typography>{message}</Typography>
                </div>
            ))}
            <Typography className={classes.decision}>
                {decision === "Approved" ? "The excursion is supported" : "The excursion is not supported"}
            </Typography>
        </div>
    );
});
